import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { useTranslation } from 'react-i18next';

export default function Icon({ icon, className, family = 'fal', onClick, style, title }) {
    const [realIcon, setRealIcon] = useState();
    const { t } = useTranslation();

    useEffect(() => {
        const i = (family === 'fal') ? fal[icon] : ((family === 'fas') ? fas[icon] : fab[icon]);
        setRealIcon(typeof i === 'undefined' ? null : i);
    }, [icon, family])

    return realIcon && (<FontAwesomeIcon
        icon={realIcon}
        className={className}
        onClick={onClick}
        style={style}
        title={t(title)}
    />);
}
